<div
  id="button-container"
  class="px-2 w-100"
  [ngStyle]="{
    'min-height.px': containerMinHeight,
  }"
>
  <div
    class="button-wrapper text-unselectable"
    id="button-wrapper"
    [ngClass]="{
      'screen-blur': currentCartStatus !== 'LOADED',
      'd-none':
        (!basketEnabled || isAdminOrderCaptureUpdate) &&
        !(isAdminOrderCaptureUpdate && orderCaptureEnabled),
      'show-always-view': showAlways,
      'regular-view': !showAlways,
      'admin-mode': isAdminOrderCaptureUpdate,
      'sidebar-open': isSidebarOpen && isAdminOrderCaptureUpdate,
      'pl-1 pr-1': !showAlways,
      'p-1':
        !showAlways &&
        (showStandalonePaymentButton() ||
          showViewOrderWithValueButton() ||
          showViewOrderWithoutValueButton()),
    }"
    [ngStyle]="{
      bottom:
        'calc(' +
        (isGoApp ? customerFooterHeight + cookieBarHeight : cookieBarHeight) +
        'px + max(var(--safe-area-inset-bottom, 0px), var(--app-bottom-bar-height, 0px)))',
      width:
        (isAdminOrderCaptureUpdate || showAlways) && elementWidth > 0
          ? elementWidth + 'px'
          : null,
      left:
        (isAdminOrderCaptureUpdate || showAlways) &&
        elementLeft != null &&
        elementLeft >= 0
          ? elementLeft + 'px'
          : null,
      'max-width.px': elementWidth > 0 && showAlways ? elementWidth : null,
      visibility:
        showStandalonePaymentButton() ||
        showViewOrderWithValueButton() ||
        showViewOrderWithoutValueButton()
          ? 'visible'
          : 'hidden',
    }"
    *ngIf="selectedCatalog !== -1"
  >
    <app-button
      *ngIf="showStandalonePaymentButton()"
      variant="dark"
      size="large"
      [classes]="'payOnline w-100 mobile-button dark'"
      (click)="onPayOnline()"
    >
      {{ 'public.standalonepayment.paymentpage.title' | translate }}
    </app-button>
    <div class="w-100 mx-auto order">
      <app-button
        (click)="currentCartStatus === 'LOADED' && onViewOrder($event)"
        variant="dark"
        size="large"
        [classes]="'w-100'"
        *ngIf="showViewOrderWithValueButton()"
      >
        <div class="d-flex w-100 align-items-center view-order-content">
          <span class="count-badge">{{ totalQuantity }}</span>
          <span class="view-order-label">{{
            'public.global.viewOrder' | translate
          }}</span>
          <span class="total-price">{{
            cartItemsTotalValue
              | formatPrice
                : selectedStoreLocale
                : selectedStoreCurrency
                : selectedStoreCurrencySymbol
          }}</span>
        </div>
      </app-button>
      <app-button
        (click)="currentCartStatus === 'LOADED' && onViewOrder($event)"
        variant="dark"
        size="large"
        [classes]="'w-100'"
        *ngIf="showViewOrderWithoutValueButton()"
      >
        <div class="d-flex w-100 align-items-center view-order-content">
          <span class="count-badge">{{ cartItems.length }}</span>
          <span class="view-order-label">{{
            'public.global.viewOrder' | translate
          }}</span>
          <!-- Mirrors the badge so the label stays optically centred -->
          <span class="badge-spacer" aria-hidden="true"></span>
        </div>
      </app-button>
    </div>
  </div>
</div>
